module.exports = __webpack_public_path__ + "static/media/qd_monthly-report-1.33d04e13.png";